import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('localCommunity');
const GET_COMMUNITIES = define('GET_COMMUNITIES', true);
const GET_COMMUNITY = define('GET_COMMUNITY', true);
const CREATE_COMMUNITY = define('CREATE_COMMUNITY', true);
const UPDATE_COMMUNITY = define('UPDATE_COMMUNITY', true);

const initialState = {
  loading: true,
  communities: [],
  community: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMUNITIES.PENDING:
      return {
        ...state,
        loading: true,
        communities: [],
      };
    case GET_COMMUNITIES.RESOLVED:
      return {
        ...state,
        communities: action.data,
        loading: false,
      };
    case GET_COMMUNITIES.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case GET_COMMUNITY.PENDING:
      return {
        ...state,
        loading: true,
        community: {},
      };
    case GET_COMMUNITY.RESOLVED:
      return {
        ...state,
        community: action.data,
        loading: false,
      };
    case GET_COMMUNITY.REJECTED:
      return {
        ...state,
        loading: false,
      };
    default: return state;
  }
};

export const actions = {
  getAllCommunity: () => ({
    type: GET_COMMUNITIES,
    promise: api.get('/local-communities')
  }),
  getCommunityById: (id) => ({
    type: GET_COMMUNITY,
    promise: api.get(`/local-communities/${id}`)
  }),
  createCommunity: (data) => ({
    type: CREATE_COMMUNITY,
    promise: api.post('/local-communities', data),
    success: 'New community has been created',
    error: 'Unable to create a community page'
  }),
  updateCommunity: (id, data) => ({
    type: UPDATE_COMMUNITY,
    promise: api.put(`/local-communities/${id}`, data),
    success: 'Community has been updated',
    error: 'Unable to update a community page'
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/local-community.js